import { render, staticRenderFns } from "./LedgerPage.vue?vue&type=template&id=29dfaba3"
import script from "./LedgerPage.vue?vue&type=script&lang=js"
export * from "./LedgerPage.vue?vue&type=script&lang=js"
import style0 from "./LedgerPage.vue?vue&type=style&index=0&id=29dfaba3&prod&lamg=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports